import { CohostDialogState } from '@event/types/event';
import { createContext, useContext } from 'react';

const AddCohostContext = createContext<
    | {
          handleDialogStateChange: (state: CohostDialogState) => void;
          handleSave: (extraChanges?: boolean) => Promise<void>;
          isLoading: boolean;
          selectedMembersState: [number[], React.Dispatch<React.SetStateAction<number[]>>];
          handleClose: () => void;
      }
    | undefined
>(undefined);

const useAddCohostContext = () => {
    const context = useContext(AddCohostContext);
    if (!context) throw new Error('useAddCohostContext must be used within a provider');
    return context;
};

export { AddCohostContext, useAddCohostContext };
